import { render, staticRenderFns } from "./QuestionnaireDetailTab.vue?vue&type=template&id=615fd66a&scoped=true&lang=pug"
import script from "./QuestionnaireDetailTab.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireDetailTab.vue?vue&type=script&lang=ts"
import style0 from "./QuestionnaireDetailTab.vue?vue&type=style&index=0&id=615fd66a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615fd66a",
  null
  
)

export default component.exports